// src/components/common/ToastNotification.js
import React, { useState, useEffect } from 'react';
import './ToastNotification.css';

const ToastNotification = ({ message, type = 'success', onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300);
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast ${type} ${visible ? 'show' : 'hide'}`}>
      <div className="toast-content">
        <i className={`bi ${
          type === 'success' ? 'bi-check-circle' : 
          type === 'error' ? 'bi-exclamation-circle' : 'bi-info-circle'
        }`}></i>
        <span>{message}</span>
      </div>
      <button 
        className="toast-close" 
        onClick={() => {
          setVisible(false);
          setTimeout(onClose, 300);
        }}
      >
        <i className="bi bi-x"></i>
      </button>
    </div>
  );
};

export default ToastNotification;